import React from "react";
import { Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert";
import { addToFavorite } from "../store/actions/favoriteAction";

const Cards = ({ film }) => {
  const dispatch = useDispatch();
  const { favorite } = useSelector((state) => state.favoriteReducer);
  function addFavoriteHandler() {
    const result = favorite.filter(
      (favorite) => favorite.imdbID === film.imdbID
    );

    if (result.length === 1) {
      swal("already added to favorite!", "", "error");
    } else {
      dispatch(addToFavorite(film));
      swal("Success add to favorite!", "", "success");
    }
  }
  return (
    <>
      <Card
        style={{ width: "18rem", border: "0", marginBottom: "50px" }}
        className="col-sm-3"
      >
        <Card.Img
          style={{ height: "250px", borderRadius: "10px 10px 0 0" }}
          variant="top"
          src={film.Poster}
        />
        <Card.Body className="border shadow">
          <Card.Title>{film.Title}</Card.Title>
          <Link
            to={{
              pathname: `/detailMovie/${film.Title.split(" ").join("-")}`,
              state: film,
            }}
          >
            <Button variant="info">See Details</Button>
          </Link>
          <Button
            onClick={() => addFavoriteHandler()}
            style={{ marginTop: "5px" }}
            variant="secondary"
          >
            Add To Favorite
          </Button>
        </Card.Body>
      </Card>
    </>
  );
};

export default Cards;
